// src/utils/generatePdfBlob.js
import {Document, Page, Text, View, Image, pdf} from '@react-pdf/renderer';
import LOGO from '../../../../assets/logo.png';
import React from 'react';
import styles from '../styles';
import ClientDetailsInfo from '../ClientDetailsInfoPDF';
import TickSvg from '../TickSvg';

const SectionHeader = ({text}) => (
  <View style={styles.sectionHeader}>
    <Text style={[styles.text, styles.bold]}>{text.toUpperCase()}:</Text>
  </View>
);

const ControlRow = ({label, value = 0, comment}) => (
  <View style={styles.row}>
    <View style={[styles.row, styles.width51]}>
      <View style={[styles.flex1, styles.contentSection]}>
        <Text style={styles.text}>{label}</Text>
      </View>
      <View style={[styles.flex1, styles.row]}>
        <View
          style={[
            styles.flex1,
            styles.borderLeft,
            styles.contentSection,
            styles.center,
          ]}>
          {value.toString() === '1' && <TickSvg width="8px" />}
        </View>
        <View
          style={[
            styles.flex1,
            styles.borderLeft,
            styles.contentSection,
            styles.center,
          ]}>
          {value.toString() === '2' && <TickSvg width="8px" />}
        </View>
        <View
          style={[
            styles.flex1,
            styles.borderLeft,
            styles.contentSection,
            styles.center,
          ]}>
          {value.toString() === '3' && <TickSvg width="8px" />}
        </View>
      </View>
    </View>
    <View style={[styles.contentSection, styles.flex1, styles.borderLeft]}>
      <Text style={styles.text}>{comment}</Text>
    </View>
  </View>
);

const generatePDFBlob = async (payload, signatureUrl) => {
  const {
    elevator,
    date,
    ordinalNr,
    client,
    address,
    elevatorId,
    project,
    period,
    type,
    images,
    ...props
  } = payload;

  const TYPES = {
    elevator: 'ElevatorControlList',
    escalator: 'EscalatorControlList',
  };

  const Klass = TYPES['elevator'] || React.Fragment;

  // i have opened the components control list and footer , because they were not getting converted in the blob

  const doc = (
    <Document
      title={`${payload.elevator} service report`}
      author="Uplift L.L.C">
      {/* Page 1: Client details and control list */}
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>
            FORMULARI I SERVISIMIT TË RREGULLT TË ASHENSORIT
          </Text>
          <Image src={LOGO} style={styles.logo} />
        </View>
        <Text style={styles.date}>Data: {payload.date}</Text>
        <ClientDetailsInfo
          ordinalNr={ordinalNr}
          client={client}
          elevator={elevator}
          address={address}
          elevatorId={elevatorId}
          project={project}
          period={period}
          type={type}
        />

        <View style={styles.table}>
          <View style={[styles.sectionHeader, styles.noBorder]}>
            <Text style={[styles.text, styles.center, styles.bold]}>
              LISTA KONTROLLUESE
            </Text>
          </View>
          <View style={styles.row}>
            <View style={[styles.row, styles.width51]}>
              <View style={[styles.flex1, styles.contentSection]} />
              <View style={[styles.flex1, styles.row]}>
                <View
                  style={[
                    styles.flex1,
                    styles.borderLeft,
                    styles.contentSection,
                  ]}>
                  <Text style={styles.text}>Në{'\n'}rregull</Text>
                </View>
                <View
                  style={[
                    styles.flex1,
                    styles.borderLeft,
                    styles.contentSection,
                  ]}>
                  <Text style={styles.text}>Kërkohet{'\n'}riparimi</Text>
                </View>
                <View
                  style={[
                    styles.flex1,
                    styles.borderLeft,
                    styles.contentSection,
                    styles.noPadding,
                  ]}>
                  <Text style={styles.text}>Riparuar/ Ndërruar</Text>
                </View>
              </View>
            </View>
            <View
              style={[styles.contentSection, styles.flex1, styles.borderLeft]}>
              <Text style={styles.text}>Komenti</Text>
            </View>
          </View>

          <SectionHeader text="lista e komponentëve të sigurisë" />
          <ControlRow
            label="Kyçi i derës së kabinës"
            value={props.c1}
            comment={props.c1Comment}
          />
          <ControlRow
            label="Kyçet e dyerve të jashtme"
            value={props.c2}
            comment={props.c2Comment}
          />
          <ControlRow
            label="Buferat"
            value={props.c3}
            comment={props.c3Comment}
          />
          <ControlRow
            label="Frenat e kabinës"
            value={props.c4}
            comment={props.c4Comment}
          />
          <ControlRow
            label="Rregullatori i shpejtësisë"
            value={props.c5}
            comment={props.c5Comment}
          />
          <ControlRow
            label="Valvula e sigurisë"
            value={props.c6}
            comment={props.c6Comment}
          />
          <SectionHeader text="qarku sigurues" />
          <ControlRow
            label="Kontakti i dyerve të kabinës"
            value={props.c7}
            comment={props.c7Comment}
          />
          <ControlRow
            label="Kontaktet e dyerve të jashtme të kateve"
            value={props.c8}
            comment={props.c8Comment}
          />
          <ControlRow
            label="Kontakti i frenave të kabinës"
            value={props.c9}
            comment={props.c9Comment}
          />
          <ControlRow
            label="Kontakti i rregullatorit të shpejtësisë"
            value={props.c10}
            comment={props.c10Comment}
          />
          <ControlRow
            label="Kufitaret (i larti, i poshtmi & i pistonit"
            value={props.c11}
            comment={props.c11Comment}
          />
          <ControlRow
            label="Stop butonat (në revizion, në PIT)"
            value={props.c12}
            comment={props.c12Comment}
          />
          <SectionHeader text="motorri" />
          <ControlRow
            label="Pulexho i motorrit/ndihmës/vajosja"
            value={props.c13}
            comment={props.c13Comment}
          />
          <ControlRow
            label="Frenat/Bobina"
            value={props.c14}
            comment={props.c14Comment}
          />
          <ControlRow
            label="Mbajtësi"
            value={props.c15}
            comment={props.c15Comment}
          />
          <SectionHeader text="kabina" />
          <ControlRow
            label="Ndalesat në kate"
            value={props.c16}
            comment={props.c16Comment}
          />
          <ControlRow
            label="Ndriçimi"
            value={props.c17}
            comment={props.c17Comment}
          />
          <ControlRow
            label="Butonat/display"
            value={props.c18}
            comment={props.c18Comment}
          />
          <SectionHeader text="dyert e kabinës" />
          <ControlRow
            label="Hapja dhe mbyllja"
            value={props.c19}
            comment={props.c19Comment}
          />
          <ControlRow
            label="Mekanizmi (rollerat, shpate, etj.)"
            value={props.c20}
            comment={props.c20Comment}
          />
          <ControlRow
            label="Panellat e dyerve"
            value={props.c21}
            comment={props.c21Comment}
          />
          <ControlRow
            label="Senzorat"
            value={props.c22}
            comment={props.c22Comment}
          />
          <SectionHeader text="dyert e jashtme" />
          <ControlRow
            label="Hapja dhe mbyllja"
            value={props.c23}
            comment={props.c23Comment}
          />
          <ControlRow
            label="Mekanizmi (rollerat, panelat)"
            value={props.c24}
            comment={props.c24Comment}
          />
          <ControlRow
            label="Rrëshqitëset dhe pragjet"
            value={props.c25}
            comment={props.c25Comment}
          />
          <ControlRow
            label="Thirrjet dhe display"
            value={props.c26}
            comment={props.c26Comment}
          />
          <SectionHeader text="blloku valvulave" />
          <ControlRow
            label="Niveli i vajit në rezervuar"
            value={props.c27}
            comment={props.c27Comment}
          />
          <ControlRow
            label="Rrjedhje të brendshme"
            value={props.c28}
            comment={props.c28Comment}
          />
          <ControlRow
            label="Pompa e dorës"
            value={props.c29}
            comment={props.c29Comment}
          />
          <ControlRow
            label="Valvula e lëshimit manual"
            value={props.c30}
            comment={props.c30Comment}
          />
          <SectionHeader text="gropa e ashensorit" />
          <ControlRow
            label="Lubrifikimi i shinave"
            value={props.c31}
            comment={props.c31Comment}
          />
          <ControlRow
            label="Pastrimi i Gropës"
            value={props.c32}
            comment={props.c32Comment}
          />
          <ControlRow
            label="SISTEMI EMERGJENT"
            value={props.c33}
            comment={props.c33Comment}
          />
          <SectionHeader text="komente shtesë" />
          <ControlRow label=" " value={props.c34} comment={props.c34Comment} />
          <ControlRow label=" " value={props.c35} comment={props.c35Comment} />
          <ControlRow label=" " value={props.c36} comment={props.c36Comment} />
        </View>

        <View style={styles.footer}>
          <View style={[styles.row, styles.spaceBetween]}>
            <View
              style={[styles.row, styles.footerSign, {position: 'relative'}]}>
              <Text style={styles.text}>Serviseri:</Text>
              {signatureUrl ? (
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <View style={[styles.flex1, styles.borderBottom]} />
                  <Text style={styles.text}>
                    _____________________________________
                  </Text>
                  <Image
                    src={signatureUrl}
                    alt="signature"
                    style={{
                      width: 50,
                      height: 50,
                      position: 'absolute',
                      top: -20,
                      left: 20,
                    }}
                  />
                </View>
              ) : (
                <Text style={styles.text}>
                  _____________________________________
                </Text>
              )}
            </View>
            <View style={[styles.row, styles.footerSign]}>
              <Text style={styles.text}>Klienti:</Text>
              <Text style={styles.text}>
                _____________________________________
              </Text>
            </View>
          </View>
          <View style={styles.center}>
            <Text style={[styles.text, styles.uplift]}>UPLIFT L.L.C</Text>
            <Text style={styles.info}>
              Tel: 048 651 651 &#183; web: www.uplift-ks.com &#183; e-mail:
              info@uplift-ks.com
            </Text>
          </View>
        </View>
      </Page>

      {/* Page 2: Images section */}
      <Page size="A4" style={styles.page}>
        <View style={[styles.header, {marginBottom: 50}]}>
          <Text style={styles.title}>SEKSION FOTOGRAFIK</Text>
          <Image src={LOGO} style={styles.logo} />
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            gap: '10px',
          }}>
          {images &&
            images.map((image, index) => (
              <Image
                key={index}
                src={image}
                style={{
                  width: '30%',
                  height: 'auto',
                  objectFit: 'cover',
                  borderRadius: '5px',
                }}
              />
            ))}
        </View>
        <View style={styles.footer}>
          <View style={[styles.row, styles.spaceBetween]}>
            <View
              style={[styles.row, styles.footerSign, {position: 'relative'}]}>
              <Text style={styles.text}>Serviseri:</Text>
              {signatureUrl ? (
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <View style={[styles.flex1, styles.borderBottom]} />
                  <Text style={styles.text}>
                    _____________________________________
                  </Text>
                  <Image
                    src={signatureUrl}
                    alt="signature"
                    style={{
                      width: 50,
                      height: 50,
                      position: 'absolute',
                      top: -20,
                      left: 20,
                    }}
                  />
                </View>
              ) : (
                <Text style={styles.text}>
                  _____________________________________
                </Text>
              )}
            </View>
            <View style={[styles.row, styles.footerSign]}>
              <Text style={styles.text}>Klienti:</Text>
              <Text style={styles.text}>
                _____________________________________
              </Text>
            </View>
          </View>
          <View style={styles.center}>
            <Text style={[styles.text, styles.uplift]}>UPLIFT L.L.C</Text>
            <Text style={styles.info}>
              Tel: 048 651 651 &#183; web: www.uplift-ks.com &#183; e-mail:
              info@uplift-ks.com
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  const blob = await pdf(doc).toBlob();
  return blob;
};

export default generatePDFBlob;
